module.exports = __webpack_public_path__ + "static/media/seo_social_media.7717990f.svg";